import { render, staticRenderFns } from "./DesignComponentsBadge.vue?vue&type=template&id=5fded6b8&scoped=true"
import script from "./DesignComponentsBadge.vue?vue&type=script&lang=js"
export * from "./DesignComponentsBadge.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsBadge.vue?vue&type=style&index=0&id=5fded6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fded6b8",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsBadge.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports